// import { take, call, put, select } from 'redux-saga/effects';

import { LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"
import {
  getSurveyTypesFailed,
  getSurveyTypesSuccess,
  getSurveyTypesWatcher,
} from "./actions"
import { call, put, takeLatest } from "redux-saga/effects"
import {
  GET_SURVEY_TYPES_WATCHER,
  GET_SWITCH_SURVEY_TYPES_WATCHER,
} from "./constants"
import axios from "axios"

export function switchSurveyTypesApi(id, data) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/surveytypes/${id}`,
    data,
  })
}

export function* getSwitchSurveyTypesSaga(action) {
  try {
    const { payload } = action
    const { status } = yield call(
      switchSurveyTypesApi,
      payload.id_company_has_survey_type,
      { active: payload.active }
    )
    if (status === 200) {
      yield put(getSurveyTypesWatcher())
    }
  } catch (e) {
    console.error(e)
  }
}

export function getSurveyTypesApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/surveytypes`,
    params: { id_company: LOCAL_COMPANY_ID() },
  })
}

export function* getSurveyTypesSaga() {
  try {
    const { data, status } = yield call(getSurveyTypesApi)
    if (status === 200) {
      yield put(getSurveyTypesSuccess(data))
    }
  } catch (e) {
    yield put(getSurveyTypesFailed())
    console.log(e)
  }
}

// Individual exports for testing
export default function* customIndicatorsSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_SWITCH_SURVEY_TYPES_WATCHER, getSwitchSurveyTypesSaga)
}
